module.exports = __webpack_public_path__ + "img/ye.9347b147.svg";